/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Validation_Template_RequiredInputs */

const en_cas_validation_template_required = /** @type {(inputs: Cas_Validation_Template_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template is required when visibility is enabled`)
};

/**
* | output |
* | --- |
* | "Template is required when visibility is enabled" |
*
* @param {Cas_Validation_Template_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_validation_template_required = /** @type {((inputs?: Cas_Validation_Template_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Validation_Template_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_validation_template_required(inputs)
});